import { ChangeDetectionStrategy, Component, effect, inject, input, LOCALE_ID } from '@angular/core';
import { SalaryExternalSystemsComponent } from './_components/salary-external-systems.component';
import { SalaryLedgerPendingComponent } from './_components/salary-ledger-pending.component';
import { SalarySettlementBonusesComponent } from './_components/salary-settlement-bonuses.component';
import { SalarySummaryComponent } from './_components/salary-summary.component';
import { DriversSalaryV2StateService } from './_services/drivers-salary-v2.state.service';

@Component({
	selector: 'app-drivers-salary-v2',
	standalone: true,
	imports: [
		SalaryExternalSystemsComponent,
		SalarySettlementBonusesComponent,
		SalaryLedgerPendingComponent,
		SalarySummaryComponent,
	],
	templateUrl: './drivers-salary-v2.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DriversSalaryV2StateService, { provide: LOCALE_ID, useValue: 'pl-PL' }],
})
export class DriversSalaryV2Component {
	readonly driverId = input.required<string>();
	readonly selectedMonth = input.required<string>();
	readonly active = input<boolean>(false);

	private readonly state = inject(DriversSalaryV2StateService);

	constructor() {
		effect(
			() => {
				this.state.setContext(this.driverId(), this.selectedMonth());
				if (this.active()) {
					this.state.reload();
				}
			},
			{ allowSignalWrites: true },
		);
	}
}
